import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.css'],
  standalone: false
})
export class CarouselComponent {
  private _imagenes: any[] = [];

isLoading = true;

@Input() set imagenes(value: any[] | null | undefined) {
  if (value) {
    this._imagenes = value;
    this.isLoading = false;
  }
}
  get imagenes(): any[] {
    return this._imagenes;
  }

  @Output() imageClick = new EventEmitter<number>();
  @Input() showThumbs: boolean = true;

  isMobile = window.innerWidth <= 769;

  ngOnInit() {
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth <= 769;
    });
  }

  onImageClick(img: any, index: number) {
    if (this.showThumbs) {
      this.imageClick.emit(index); // caso Detail → abre modal
    } else {
      this.imageClick.emit(img);   // caso Home → emite la propiedad
    }
  }
}
